// print env info
import getEnv, { getBuildEnv } from 'utils/getEnv'

// eslint-disable-next-line
console.log(`\
env: ${getEnv()}
build env: ${getBuildEnv()}
hash: ${process.env.__hash__}
last update: ${process.env.__update__}
publish date: ${process.env.__publish_at__}
============
`)
